import { createFileRoute } from "@tanstack/react-router";
import { ArticleLayout } from "@/components/article-layout";
import { getArticle } from "@/content/articles";
import { abs, articleHead } from "@/content/seo";
import cover from "@/assets/sylwia-scena-ekran.jpg.asset.json";

const article = getArticle("psychologia-przywodztwa");

export const Route = createFileRoute("/psychologia-przywodztwa")({
  head: () => articleHead(article, abs(cover.url)),
  component: () => <ArticleLayout article={article} />,
});
